export default "__VITE_ASSET__Cms$rdJM__"